<template>
  <ul class="indentation-blocks">
    <indentation-block
      v-for="block in blocks"
      :key="block.headline"
      :infos="block"
    />
  </ul>
</template>

<script>
import IndentationBlock from './IndentationBlock.vue'

export default {
  components: {
    IndentationBlock
  },
  data () {
    return {
      blocks: this.$store.state.breaks
    }
  }
}
</script>

<style lang="scss">
.indentation-blocks {
  display: grid;
  grid-row-gap: var(--site-padding);
  grid-template-columns: minmax(16rem, 1fr);
  padding: 0;
}
</style>
